import React from "react";
import i18n from "../../../i18n/i18n";
import {ITicketStore} from "../../stores/ticketStore";
import SingleDangerousGood from "./singleDangerousGood";
import Button from "../../../common/components/shared/button/button";
import {observer} from "mobx-react";
import {Popup} from "../../../common/components/shared/popup/popup";
import {ReactComponent as RemoveIcon} from "../../../statics/icons/icon_remove.svg";
import {isDangerousGood} from "../../../helpers/dangerousGoods";
import "./dangerousGood.scss";
import {IOrderStore} from "../../stores/orderStore";

interface DangerousGoodsSectionProps {
    store: ITicketStore | IOrderStore;
}

interface DangerousGoodsSectionState {
    selectedElement: number | undefined;
    displayRemovePopup: boolean;
}

class DangerousGoodsSection extends React.Component <DangerousGoodsSectionProps, DangerousGoodsSectionState> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedElement: undefined,
            displayRemovePopup: false
        };
    }

    get store() {
        return this.props.store;
    }

    render() {
        const isDangerousGoodCargoType = this.store.cargoType && this.store.cargoType.value !== "" ? isDangerousGood(this.store.cargoType.value) : false;

        return (
            <div className="dangerous-goods-section section">
                <div className="section-header">
                    {i18n.t("transportation.ticket.details.dangerousGoods.header")}
                </div>
                <div className="section-content">
                    {isDangerousGoodCargoType && this.store.dangerousGoods && this.store.dangerousGoods.length === 0 &&
                        <div className="section-empty-dangerous-goods error-message">
                            {i18n.t("transportation.ticket.details.dangerousGoods.thereMustBeAtLeastOne")}
                        </div>
                    }
                    {this.store.dangerousGoods.map((element, dangerousGoodId) =>
                        <SingleDangerousGood
                            key={`single-dangerous-good-${dangerousGoodId}`}
                            dangerousGoodId={dangerousGoodId}
                            onRemoveAction={() => this.setState({
                                selectedElement: dangerousGoodId,
                                displayRemovePopup: true
                            })}
                            isDangerousGood={isDangerousGoodCargoType}
                            store={this.props.store}
                        />
                    )}
                    <div className="actions">
                        <Button
                            text={i18n.t("transportation.ticket.actions.addNextDangerousGood")}
                            type="primary"
                            variant="text"
                            className="add-next-dangerous-good-btn"
                            testId="add-next-dangerous-good"
                            onClick={() => this.addNextDangerousGood()}
                        />
                    </div>
                </div>
                {this.renderRemovePopup(this.confirmRemove.bind(this))}
            </div>
        );
    }

    private addNextDangerousGood() {
        this.store.createDangerousGood();

        const cargoType = this.store.cargoType ? this.store.cargoType.value : "";

        if (cargoType !== "") {
            const requireUnCodeValidator = {
                name: "requireUnCodeValidator",
                fn: (value: string) => {
                    return (isDangerousGood(cargoType) && !!value) || !isDangerousGood(cargoType);
                },
                errorMessage: () => `${i18n.t("errorMessages.required")}`
            };

            this.store.dangerousGoods.forEach((item) => {
                // Adding only for new items
                if (item.unCodeId && !item.unCodeId.validators) {
                    item.unCodeId.addValidators([requireUnCodeValidator]);
                }

                if (item.weight && !item.weight.validators) {
                    item.weight.addValidators([requireUnCodeValidator]);
                }
            });
        }
    }

    protected renderRemovePopup(confirmRemove: any) {
        const content = <div>
            <p>{i18n.t("timetable.actions.removeAction.line1")}</p>
            <p>{i18n.t("timetable.actions.removeAction.line2")}</p>
        </div>;

        return (
            <Popup
                open={this.state.displayRemovePopup}
                className="remove-popup popup-with-secondary-button-color"
                header={i18n.t("timetable.actions.removeAction.header")}
                secondHeader={i18n.t("timetable.actions.removeAction.secondHeader")}
                icon={<RemoveIcon/>}
                content={content}
                actionText={i18n.t("timetable.actions.removeAction.actionText")}
                action={confirmRemove}
                cancel={() => this.setState({displayRemovePopup: false})}
                testId="remove-popup"
            />
        );
    }

    private confirmRemove() {
        if (this.state.selectedElement !== undefined) {
            this.store.removeDangerousGood(this.state.selectedElement);

            this.setState({selectedElement: undefined, displayRemovePopup: false});
        }
    }
}

export default observer(DangerousGoodsSection);